
export const SET_TRAINING_COURSE = 'SET_TRAINING_COURSE';

export const setTraningCourse = (data: any) => {
    return {
        type: SET_TRAINING_COURSE,
        data
    }
}

